import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Stack } from 'common/ui/Layout';
import Text from 'common/ui/Text';
import { Colors } from 'styles';
import Tooltip from 'common/ui/Tooltip';
import { rootTheme } from 'theme/rootTheme';

export const TOOLTIP_DELAY = 500;

type MarkAsDiscrepantToggleProps = {
  isDisabled?: boolean;
  hasDiscrepantResult?: boolean;
  onToggle: (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void | Promise<void>;
};

export const MarkAsDiscrepantToggle = ({
  isDisabled = false,
  hasDiscrepantResult = false,
  onToggle,
}: MarkAsDiscrepantToggleProps) => {
  return (
    <Tooltip
      delay={[TOOLTIP_DELAY, 0]}
      content={
        <Text
          variant="body2"
          css={`
            color: ${Colors.gray1};
          `}
        >
          Say "<b>{hasDiscrepantResult ? 'Clear' : 'Flag'} discrepancy"</b>
        </Text>
      }
      backgroundColor={Colors.gray8}
    >
      <Stack
        alignY="center"
        alignX="center"
        css={`
          padding: 2px 8px 2px 4px;
          border-radius: ${rootTheme.radius.sm}px;
          opacity: ${isDisabled ? 0.5 : 1};
          border: 1px solid ${hasDiscrepantResult ? '#EE5F55' : 'transparent'};
          background-color: ${hasDiscrepantResult ? 'rgba(238, 95, 85, 0.16)' : 'transparent'};
          cursor: pointer;
        `}
      >
        <FormControlLabel
          disabled={isDisabled}
          labelPlacement="start"
          label={
            <Text css={hasDiscrepantResult ? `color: ${Colors.red7}; font-weight: 500;` : ''}>
              Prelim Discrepancy
            </Text>
          }
          control={
            <Switch
              disabled={isDisabled}
              size="small"
              data-testid="mark-as-discrepant-toggle"
              checked={hasDiscrepantResult}
              onChange={onToggle}
              sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                  color: Colors.red6,
                },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                  backgroundColor: Colors.red4,
                  opacity: 1,
                },
              }}
            />
          }
          onClick={(e) => e.stopPropagation()}
        />
      </Stack>
    </Tooltip>
  );
};

MarkAsDiscrepantToggle.displayName = 'MarkAsDiscrepantToggle';
